import {Locales} from '@netx/core-next/locales';

import {
	AttributeType,
	ATTRIBUTE_SYSTEM,
	ATTRIBUTE_SYSTEM_ID,
	ATTRIBUTE_OBJECT_TYPE,
} from './constants';
import {AttributeSystemType} from './types';

export const AttributeObjectTypeLabel = Locales((i18n) => ({
	[ATTRIBUTE_OBJECT_TYPE.ASSET]: i18n('i18n.asset'),
	[ATTRIBUTE_OBJECT_TYPE.CLIP]: i18n('i18n.clip'),
}));

export const AttributeSystemAttributesLabel = Locales((i18n) => ({
	ROUTE: i18n('i18n.attributes'),
}));

export const AttributeSystemMetadataMapsLabel = Locales((i18n) => ({
	ROUTE: i18n('i18n.metadataMaps'),
}));

export const AttributeSystemSemanticsLabel = Locales((i18n) => ({
	ROUTE: i18n('i18n.semantics'),
}));

export const TYPE_LABELS = Locales<Record<AttributeType, string>>((i18n) => ({
	[AttributeType.DATE]: i18n('i18n.date'),
	[AttributeType.HIERARCHICAL]: i18n('i18n.hierarchical'),
	[AttributeType.MULTISELECT]: i18n('i18n.multiSelectBox'),
	[AttributeType.NUMBER]: i18n('i18n.number'),
	[AttributeType.SELECT]: i18n('i18n.pulldown'),
	[AttributeType.SEMANTIC]: i18n('i18n.semantic'),
	[AttributeType.TAG]: i18n('i18n.tag'),
	[AttributeType.TAG_VOCAB]: i18n('i18n.tagVocab'),
	[AttributeType.TEXT]: i18n('i18n.text'),
	[AttributeType.TEXTAREA]: i18n('i18n.textarea'),
}));

export const SYSTEM_ATTRIBUTE_LABELS = Locales<
	Record<AttributeSystemType, string>
>((i18n) => ({
	[ATTRIBUTE_SYSTEM_ID[ATTRIBUTE_SYSTEM.ASSET_ID]]: i18n('i18n.assetId'),
	[ATTRIBUTE_SYSTEM_ID[ATTRIBUTE_SYSTEM.CATEGORY_PATHS]]:
		i18n('i18n.folderPath'),
	[ATTRIBUTE_SYSTEM_ID[ATTRIBUTE_SYSTEM.CHECKSUM]]: i18n('i18n.checksum'),
	[ATTRIBUTE_SYSTEM_ID[ATTRIBUTE_SYSTEM.CREATION_DATE]]:
		i18n('i18n.creationDate'),
	[ATTRIBUTE_SYSTEM_ID[ATTRIBUTE_SYSTEM.DIMENSIONS]]: i18n('i18n.dimensions'),
	[ATTRIBUTE_SYSTEM_ID[ATTRIBUTE_SYSTEM.EXPIRE_DATE]]: i18n('i18n.expires'),
	[ATTRIBUTE_SYSTEM_ID[ATTRIBUTE_SYSTEM.FILE]]: i18n('i18n.file'),
	[ATTRIBUTE_SYSTEM_ID[ATTRIBUTE_SYSTEM.FILE_FORMAT_FAMILY]]: i18n(
		'i18n.fileFormatFamily',
	),

	[ATTRIBUTE_SYSTEM_ID[ATTRIBUTE_SYSTEM.FILE_SIZE_2]]: i18n('i18n.fileSize'),
	[ATTRIBUTE_SYSTEM_ID[ATTRIBUTE_SYSTEM.FILE_TYPE_LABEL]]:
		i18n('i18n.fileType'),
	[ATTRIBUTE_SYSTEM_ID[ATTRIBUTE_SYSTEM.HEIGHT]]: i18n('i18n.height'),
	[ATTRIBUTE_SYSTEM_ID[ATTRIBUTE_SYSTEM.IMPORT_DATE]]: i18n('i18n.importDate'),
	[ATTRIBUTE_SYSTEM_ID[ATTRIBUTE_SYSTEM.MOD_DATE]]: i18n('i18n.modDate'),
	[ATTRIBUTE_SYSTEM_ID[ATTRIBUTE_SYSTEM.MOD_USER]]: i18n('i18n.modUser'),
	[ATTRIBUTE_SYSTEM_ID[ATTRIBUTE_SYSTEM.NAME]]: i18n('i18n.name'),
	[ATTRIBUTE_SYSTEM_ID[ATTRIBUTE_SYSTEM.PATH]]: i18n('i18n.path'),
	[ATTRIBUTE_SYSTEM_ID[ATTRIBUTE_SYSTEM.SMART_LABELS]]:
		i18n('i18n.smartLabels'),
	[ATTRIBUTE_SYSTEM_ID[ATTRIBUTE_SYSTEM.THUMB_PATH]]: i18n('i18n.thumbPath'),
	[ATTRIBUTE_SYSTEM_ID[ATTRIBUTE_SYSTEM.WIDTH]]: i18n('i18n.width'),
}));

export const AttributeExportTitle = Locales((i18n) => ({
	DOWNLOAD: i18n('i18n.exportAttributes'),
	SHARE: i18n('i18n.exportAttributes'),
}));

export const AttributeExportSubTitle = Locales((i18n) => ({
	NEW: i18n('i18n.new'),
	EDIT: i18n('i18n.edit'),
}));
